export default "__VITE_ASSET__pMhs83aH__"